<template>
  <div style="width: 100%" class="row-view">
    <el-date-picker
      style="flex: 1"
      v-model="time1"
      type="date"
      :size="size"
      format="yyyy-MM-dd"
      value-format="yyyy-MM-dd"
      placeholder="开始日期"
      @change="onTime(1)"
    />
    <div style="margin-left: 10px;margin-right: 10px">至</div>
    <el-date-picker
      style="flex: 1"
      v-model="time2"
      type="date"
      :size="size"
      value-format="yyyy-MM-dd"
      format="yyyy-MM-dd"
      placeholder="结束日期"
      @change="onTime(2)"
    />
    <!--    <el-date-picker-->
    <!--      v-model="time"-->
    <!--      :size="size"-->
    <!--      type="daterange"-->
    <!--      range-separator="至"-->
    <!--      start-placeholder="开始日期"-->
    <!--      end-placeholder="结束日期"-->
    <!--      format="yyyy-MM-dd"-->
    <!--      value-format="yyyy-MM-dd"-->
    <!--      :picker-options="pickerOptions1"-->
    <!--      :default-value="new Date()"-->
    <!--      @change="onTime"-->
    <!--    />-->

  </div>
</template>
<style lang="scss" scoped>
.el-button{
  margin-left: 10px;
}
</style>
<script>
export default {
  props: {
    timeArr: {
      type: Array,
      default: () => {
        return ['昨天', '今天', '近7日', '近30日']
      }
    },
    size: {
      type: String,
      default: 'default'
    },
    timeState: {
      type: Boolean,
      default: false
    },
    default_today:{
      type:Number,
      default: 0
    },
    showDay: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      time1: '',
      time2: '',
      time: [],
      timeIng: [],
      today: this.default_today,
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      }
    }
  },

  created() {
    this.$emit('onDay', this.today)
    this.defaultDate()
    if (this.timeState) {
      this.time = this.timeIng
    }
  },
  methods: {
    onClear() {
      this.time1 = ''
      this.time2 = ''
      this.time = []
      this.today = 0
    },
    onTime(num) {
      if (!this.time) {
        this.time = []
      }
      this.time = [this.time1, this.time2]
      this.today = 0
      this.$emit('onTime', this.time)
    },
    onDay(num) {
      this.time1 = ''
      this.time2 = ''
      this.time = []
      this.today = num
      this.$emit('onDay', this.today)
    },
    defaultDate() {
      // 获取新的时间(2019.4.12）
      const date = new Date()
      // 获取当前时间的年份转为字符串
      const year = date.getFullYear().toString() // '2019'
      // 获取月份，由于月份从0开始，此处要加1，判断是否小于10，如果是在字符串前面拼接'0'
      const month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString() // '04'
      // 获取天，判断是否小于10，如果是在字符串前面拼接'0'
      const da = date.getDate() < 10 ? '0' + date.getDate().toString() : date.getDate().toString() // '12'
      // 字符串拼接，开始时间，结束时间
      const end = year + '-' + month + '-' + da // 当天'2019-04-12'
      const beg = year + '-' + month + '-01' // 当月第一天'2019-04-01'
      this.timeIng = [beg, end] // 将值设置给插件绑定的数据
    }
  }
}
</script>
